export default "__VITE_ASSET__Cg9wnm48__"